import { Box } from '@factorialco/deprecated-design-system'

import PreviewAttachments from 'modules/processes/components/ItemWizard/components/Preview/Attachments'
import PreviewDescription from 'modules/processes/components/ItemWizard/components/Preview/Description'
import PreviewTitle from 'modules/processes/components/ItemWizard/components/Preview/Title'
import { EmployeeInfoPreview } from './EmployeeInfoPreview'
import { IDUploadPreview } from './IDUploadPreview'
import { SocialSecurityUploadPreview } from './SocialSecurityUploadPreview'

const Preview = () => {
  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />
      <EmployeeInfoPreview />
      <IDUploadPreview />
      <SocialSecurityUploadPreview />
    </Box>
  )
}

export default Preview
